import createUseSwitchStore from '../components/common/@stores/switch';
import { type ISwitchState } from './store';
import type { TGenericSwitchStoreValue } from '../components/common/@commonTypes/switchStore';

const SwitchStore = createUseSwitchStore<ISwitchState>();

export const useSwitchStore = SwitchStore.store;
export const dispatchSwitchData = (data: Partial<ISwitchState>) =>
  SwitchStore.dispatch(data);
export const dispatchSwitch = (
  k: keyof ISwitchState,
  v: TGenericSwitchStoreValue,
) => SwitchStore.dispatchSwitch(k, v);
